import React from 'react'
import ReactLoading from 'react-loading'

export default class Loading extends React.Component {
  onCancel = () => {
    this.props.onCancel(this.props.text)
  };

  render() {
    return (
      <div className='container ' style={{width: '50px'}}>
        <ReactLoading
          type="cylon"
          color="#00999983"
          height={this.props.height || 120}
          width={this.props.width || 120}
        />
      </div>

    // <ReactLoading
    //   type="cylon"
    //   color="#00999983"
    //   height={this.props.height || 120}
    //   width={this.props.width || 120}
    // />
    )
  }
}
